<template>
  <div class="h-full w-full relative">
    <div class="w-full">
        <el-collapse class="w-full h-full" accordion @change="collapseChange" v-model="activeTab">
            <el-collapse-item
              title="视角列表"
              name="0"
              class="w-full p-0px h-full"
            >
             <div class="w-auto h-auto overflow-auto max-h-490px max-w-345px">
                <el-tree node-key="id" :data="viewTreeData" :props="defaultProps" :default-expanded-keys="defaultViewNodes" @node-click="viewNodeClick"></el-tree>
              </div>
            </el-collapse-item>
            <el-collapse-item
              title="个人收藏"
              name="1"
              class="w-full p-0px h-full"
            >
             <div class="w-345px h-215px overflow-auto">
                <el-tree node-key="id" :data="treeData" :props="defaultProps" :default-expanded-keys="defaultTreeNodes" @node-click="treeNodeClick"></el-tree>
             </div>
            </el-collapse-item>
        </el-collapse>
    </div>
    <!-- <div class="w-full">
        <el-collapse  class="w-full h-full">

        </el-collapse>
    </div> -->
    <div class="w-full h-40px absolute bottom-0px left-40/100">
        <el-button size="small" class="ml-10px" type="primary" @click="operate('add')"
        >新增</el-button>
        <el-button size="small" class="ml-10px" type="primary" @click="operate('edit')"
        >更新</el-button>
        <el-button size="small" class="ml-10px" type="primary" @click="operate('delete')"
        >删除</el-button>
    </div>
    <CockpitDialog
        v-if="showDialog"
        class="dialog"
        :title="dialogType === 'add' ? '新增' : '更新'"
        @close="closeDialog"
    >
       <el-form label-width="100px"
            class="w-full h-60px mt-30px"
            ref="form"
            :model="dialogData"
            :rules="rules"
        >
            <el-form-item label="请输入名称" prop="name">
                <el-input v-model="dialogData.name" placeholder="请输入名称"></el-input>
            </el-form-item>
        </el-form>
        <div class="absolute bottom-15px right-20px">
            <el-button type="primary" @click="dialogSubmit" class="mr-20px">确定</el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </CockpitDialog>
  </div>
</template>

<script>
import { ViewApi } from '@wiz-api/cloud-render-management'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}

const viewApi = new ViewApi()
export default {
  components: { CockpitDialog },
  name: 'ListOfPerspectives',
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTab: '0',
      defaultTreeNodes: [],
      treeData: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
      },
      defaultViewNodes: [],
      viewTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      flag: '',
      metalBimSelectValue: '',
      keyword: '',
      color: '0,1,0,0.392157',
      showDialog: false,
      dialogData: {},
      nodeData: {},
      dialogType: '',
      pointInfo: {},
      formData: {},
      clickTime: 0,
      currentPosition: [],
    }
  },
  computed: {
    usersInfo() {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      return userInfo?.profile || {}
    },
  },
  methods: {
    async initData() {
      const [err, res] = await viewApi.getViewTree()
      if (!err && res.length) {
        const rootNodeId = res[0]?.id
        this.defaultViewNodes = rootNodeId ? [rootNodeId] : []
        const rootTreeNodeId = res[1]?.id
        this.defaultTreeNodes = rootTreeNodeId ? [rootTreeNodeId] : []
        this.$set(this.viewTreeData, 0, res[0])
        this.$set(this.treeData, 0, res[1])// 获取数据
      }
    },
    closeDialog() {
      this.showDialog = false
      this.dialogData = {}
      this.dialogType = ''
      this.nodeData = {}
      //   this.currentPosition = []
      this.formData = {}
    },
    operate(type) {
      // 新增、更新、删除视角列表的节点
      if (type === 'add') {
        this.showDialog = true
        this.dialogType = type
        return
      }
      if (type === 'edit') {
        if (_.isEmpty(this.nodeData)) {
          this.$message.error('请选择要编辑的节点')
          return
        }
        this.editView('updata')
        return
      }
      this.deleteView()
    },
    async addView() {
      const resParam = await PlayerUtils.call(this.player.Native.Camera.currentParam)
      if (resParam) {
        this.formData.eye = resParam.eye
        this.formData.target = resParam.target
        this.formData.up = resParam.up
        this.$forceUpdate()
      }
      // 新增视角列表的节点
      const tempData = {
        position: _.cloneDeep(this.currentPosition),
        cameraParams: _.cloneDeep(this.formData),
      }
      const [err, res] = await viewApi.create({
        body: {
          name: this.dialogData.name ? this.dialogData.name : null,
          pId: this.nodeData.id ? this.nodeData.id : null,
          viewJson: JSON.stringify(tempData),
          uId: this.flag === 'person' ? this.usersInfo.sub : null,
        }
      })
      if (!err) {
        this.$message.success('新增成功')
        this.closeDialog()
        this.initData()
      }
    },
    async editView(type) {
      const resParam = await PlayerUtils.call(this.player.Native.Camera.currentParam)
      if (resParam) {
        this.formData.eye = resParam.eye
        this.formData.target = resParam.target
        this.formData.up = resParam.up
        this.$forceUpdate()
      }
      const tempData = {
        position: _.cloneDeep(this.currentPosition),
        cameraParams: _.cloneDeep(this.formData),
      }
      const id = type === 'updata' ? this.nodeData.id : this.dialogData.id
      const [err, res] = await viewApi.update(id, {
        body: {
          id,
          name: type === 'updata' ? this.nodeData.name : this.dialogData.name,
          viewJson: type === 'updata' ? JSON.stringify(tempData) : this.dialogData.viewJson
        }
      })
      if (!err) {
        this.$message.success('编辑成功')
        this.closeDialog()
        this.initData()
      }
    },
    deleteView() {
      if (this.nodeData.name === '根目录') this.nodeData = {}
      if (_.isEmpty(this.nodeData)) {
        this.$message.error('请选择要删除的节点')
        return
      }
      this.$confirm('确认删除该节点吗？')
        .then(async () => {
          // 接口删除节点
          const [err, res] = await viewApi.deleteView({
            id: this.nodeData.id,
            isPblic: this.flag !== 'person',
          })
          if (!err) {
            this.$message.success('删除成功')
            this.nodeData = {}
            this.initData()
          }
        })
        .catch()
    },
    collapseChange(key) {
      this.nodeData = {}
      this.flag = ''
    },
    dialogSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.currentPosition.length) {
            this.$message.error('请选择点位')
            return
          }
          if (this.dialogType === 'add') {
            // 新增视角列表的节点 接口
            this.addView()
          }
          if (this.dialogType === 'edit') {
            // 更新视角列表的节点 接口
            this.editView()
          }
        }
      })
    },
    treeNodeClick(data) {
      this.flag = 'person'
      this.nodeData = _.cloneDeep(data)
      const tempData = JSON.parse(data.viewJson)
      if (this.clickTime && data.id === this.nodeData.id) {
        clearTimeout(this.clickTime)
        this.clickTime = null
        this.showDialog = true
        this.dialogData = _.cloneDeep(data)
        this.currentPosition = tempData?.position || []
        this.dialogType = 'edit'
      } else {
        this.clickTime = setTimeout(() => {
          this.player.Native.Camera.moveTo(tempData?.cameraParams?.eye, tempData?.cameraParams?.target, tempData?.cameraParams?.up, 1)
          this.clickTime = null
        }, 400) // 400ms 的延迟来区分单击和双击
      }
    },
    viewNodeClick(data) {
      this.nodeData = JSON.parse(JSON.stringify(data))
      this.flag = 'view'
      const tempData = JSON.parse(data.viewJson)
      if (this.clickTime && data.id === this.nodeData.id) {
        clearTimeout(this.clickTime)
        this.clickTime = null
        this.showDialog = true
        this.currentPosition = tempData?.position || []
        this.dialogData = _.cloneDeep(data)
        this.dialogType = 'edit'
      } else {
        this.clickTime = setTimeout(() => {
          this.player.Native.Camera.moveTo(tempData?.cameraParams?.eye, tempData?.cameraParams?.target, tempData?.cameraParams?.up, 1)
          this.clickTime = null
        }, 400) // 400ms 的延迟来区分单击和双击
      }
    },
    // 处理点选
    handlePointSelectPosition(info) {
      this.currentPosition = info ? info.pos : []
      // 点击三维就会调用这个方法获取到的点相关的信息
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
  },
  created() {
    this.player.Native.ModelTree.EventBrowseLClick.connect(async (info) => {
      this.handlePointSelectPosition(info)
    })
    this.initData()
  },
  beforeDestroy() {
    this.backInitPositon()
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-collapse-item__content {
  padding: 0;
}
::v-deep .el-tree {
    background: #0b3e4f;
    color: #ffffff;
}
.dialog {
  left: 720px;
  top: 300px;
  width: 420px;
  height: 220px;
}
</style>
